import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c35b2712&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35b2712')) {
      api.createRecord('c35b2712', component.options)
    } else {
      api.reload('c35b2712', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c35b2712&", function () {
      api.rerender('c35b2712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/SyncInfo/index.vue"
export default component.exports